import { PaymentRedirectOverlay } from "@/pages/ReservationOverview/components/PaymentRedirectOverlay/PaymentRedirectOverlay.tsx";
import { createRoot } from "react-dom/client";

export const showPaymentRedirectOverlay = (containerEl: HTMLElement, duration = 5000) => {
  return new Promise<void>((resolve) => {
    const wrapper = document.createElement("div");
    containerEl.appendChild(wrapper);

    const handleComplete = () => {
      wrapper.remove();
      resolve();
    };

    const root = createRoot(wrapper);
    root.render(<PaymentRedirectOverlay duration={duration} onComplete={handleComplete} />);

    return {
      unmount: () => {
        root.unmount();
        wrapper.remove();
        resolve();
      },
    };
  });
};
